import * as Yup from "yup";

export const useUserValidation = () => {
  const formValidation = Yup.object({
    firstName: Yup.string()
      .required("Vorname ist erforderlich")
      .max(50, "Vorname darf höchstens 50 Zeichen lang sein"),

    lastName: Yup.string()
      .required("Nachname ist erforderlich")
      .max(50, "Nachname darf höchstens 50 Zeichen lang sein"),

      address: Yup.string()
      .required("addresse ist erforderlich")
      .max(50, "Nachname darf höchstens 50 Zeichen lang sein"),

  

    email: Yup.string()
      .email("Ungültige E-Mail-Adresse")
      .required("E-Mail ist erforderlich"),

    password: Yup.string()
      .required("Passwort ist erforderlich")
      .min(8, "Passwort muss mindestens 8 Zeichen lang sein"),

      phoneNumber: Yup.string()
      .required("Telefonnummer ist erforderlich")
      .min(2, "Telefonnummer muss mindestens 8 Zeichen lang sein")
      .matches(/^\+?\d+$/, "Telefonnummer darf nur Ziffern enthalten und optional mit + beginnen"),

    passwordConfirm: Yup.string()
      .required("Passwortbestätigung ist erforderlich")
      .oneOf([Yup.ref("password")], "Passwörter stimmen nicht überein")
      .min(8, "Passwort muss mindestens 8 Zeichen lang sein"),
  });

  return { formValidation };
};
